import { Box, Link, Stack, Text } from '@chakra-ui/react';
import type { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import { ExternalLinkIcon } from 'components';

export interface TransWithExternalLinkIconProps {
  i18nKey: string;
  link: string;
}
export const TransWithExternalLinkIcon: FunctionComponent<TransWithExternalLinkIconProps> = ({
  i18nKey,
  link,
}) => (
  <Stack direction="row">
    <Text>
      <Trans
        i18nKey={i18nKey}
        components={[
          <Link
            href={link}
            key={link}
            textDecoration="underline"
            variant="hoverBrand"
            isExternal
          />,
          <Box
            key="externalLinkIcon"
            boxSize="4"
            alignSelf="center"
            as="span"
            display="inline-block"
            ml="1"
          >
            <ExternalLinkIcon />
          </Box>,
        ]}
      />
    </Text>
  </Stack>
);
